import React, { Component } from 'react';
import Pagination from 'react-js-pagination';

export default class paginationCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meta_data: props.data,
    };
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.data && nextProps.data !== this.props.data) {
      this.setState({ meta_data: nextProps.data });
    }
  }

  handlePageChange(pageNumber) {
    if (this.state.meta_data['currentPage'] !== pageNumber) {
      this.props.handlePageChange(pageNumber);
    }
  }

  render() {
    return (
      this.state.meta_data ?
        <div className="DivPager">
          <Pagination
            activePage={this.state.meta_data['currentPage']}
            itemsCountPerPage={this.state.meta_data['defaultPageSize']}
            totalItemsCount={this.state.meta_data['totalRecords']}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange}
            prevPageText="Prev"
            nextPageText="Next"
            hideDisabled={true}
          />
          {this.state.meta_data['totalRecords'] > this.state.meta_data['defaultPageSize'] ?
            <div className="pagesize">Showing {(this.state.meta_data['currentPage'] - 1) * this.state.meta_data['defaultPageSize'] + 1} to {this.state.meta_data['currentPage'] * this.state.meta_data['defaultPageSize'] > this.state.meta_data['totalRecords'] ? this.state.meta_data['totalRecords'] : this.state.meta_data['currentPage'] * this.state.meta_data['defaultPageSize']} of {this.state.meta_data['totalRecords']} entries</div>
            : null}
        </div>
        : <div></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/paginationCustom.js